<script>
import { defineComponent } from 'vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';

export default defineComponent({
    name: 'RequestOrderConfirmation',
    components: { Button, Input },
    data() {
        return {
            email: '',
            code: '',
            postcode: '',
            loading: false,
            success: false,
            done: false,
        };
    },
    methods: {
        submit() {
            this.resetStatus();
            this.loading = true;
            this.$axios.$post('orders/search', {
                email: this.email,
                code: this.code,
                postcode: this.postcode,
            }).then(() => {
                this.success = true;
            }).catch((error) => {

            }).finally(() => {
                this.done = true;
                this.loading = false;
            });
        },
        resetStatus() {
            this.done = false;
            this.success = false;
            this.loading = false;
        },
    },
    watch: {
        email() {
            this.resetStatus();
        },
        code() {
            this.resetStatus();
        },
        postcode() {
            this.resetStatus();
        },
    },
});
</script>

<template>
    <div class="flex flex-col gap-4 text-center max-w-lg mb-12">
        <h3 class="font-heading text-3xl">
            Find my order
        </h3>
        <p>Complete at least two of the following fields to help us locate your order.</p>
        <div class="flex flex-col gap-4">
            <Input
                v-model="code"
                type="text"
                label="Order reference"
            />
            <Input
                v-model="email"
                type="email"
                label="Email address"
            />
            <Input
                v-model="postcode"
                type="text"
                label="Billing or delivery postcode"
            />
            <Button
                :loading="loading"
                :disabled="loading"
                text="Find my order"
                class="mt-1"
                @click="submit"
            />
        </div>
        <div
            v-if="done && success"
            class="bg-green-lightest p-4 rounded-lg"
        >
            <p class="mb-4">
                We've located an order using the details provided and sent the order details by email.
            </p>

            <p>If you do not receive this email please get in touch with the team using one of the options above.</p>
        </div>
        <div
            v-else-if="done"
            class="bg-red-lightest p-4 rounded-lg"
        >
            <p class="mb-4">
                We were unable to locate an order using the details provided.
            </p>

            <p>
                Please check the details provided and try again. If you continue to have issues please get in touch with the team using one of the options above.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
